import { render, staticRenderFns } from "./planInstitutionsDialog.vue?vue&type=template&id=bae660cc"
import script from "./planInstitutionsDialog.vue?vue&type=script&lang=ts"
export * from "./planInstitutionsDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports